import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-stone-200 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <div className="mb-3"><Logo className="h-16" /></div>
          <p className="text-sm text-stone-500 max-w-xs">Discover products you'll love. For Friib. Brands provide the product — you just cover shipping.</p>
        </div>
        <div>
          <h4 className="font-display font-bold text-stone-900 mb-3">Shop</h4>
          <ul className="space-y-2 text-sm text-stone-500">
            <li><Link to="/shop" className="hover:text-[var(--friib)]">Shop Friibs</Link></li>
            <li><Link to="/local" className="hover:text-[var(--friib)]">Friib Local</Link></li>
            <li><Link to="/shop?sort=newest" className="hover:text-[var(--friib)]">Fresh Drops</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold text-stone-900 mb-3">Business</h4>
          <ul className="space-y-2 text-sm text-stone-500">
            <li><Link to="/brands" className="hover:text-[var(--friib)]">List Your Products</Link></li>
            <li><Link to="/local-businesses" className="hover:text-[var(--friib)]">For Local Businesses</Link></li>
            <li><Link to="/merchant" className="hover:text-[var(--friib)]">Merchant Portal</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold text-stone-900 mb-3">Trust & Safety</h4>
          <ul className="space-y-2 text-sm text-stone-500">
            <li>Terms of Service</li><li>Privacy Policy</li><li>Shipping Policy</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-200 py-5 text-center text-xs text-stone-400">
        © {new Date().getFullYear()} Friib · Products are provided by participating merchants. You only pay disclosed shipping & handling.
      </div>
    </footer>
  );
}
